'use strict';

import { CoreRepository } from '../CoreRepository';
import { AgencyIntegrationOAuth } from '../../Entities/Agency/AgencyIntegrationOAuth';

export class AgencyIntegrationOAuthRepository extends CoreRepository {
  public getAgencyIntegrationOAuth(agencyId: number, appName: string, options: object = {}) {
    return this.webAPI.getAgencyIntegrationOAuth(agencyId, appName, options).then((response) => {
      return response;
    });
  }

  public putAgencyIntegrationOAuth(
    agencyId: number,
    appName: string,
    options: object = {},
    payload: object = {}
  ) {
    return this.webAPI
      .putAgencyIntegrationOAuth(agencyId, appName, options, payload)
      .then((response) => {
        const agencyIntegrationOAuth = new AgencyIntegrationOAuth();
        agencyIntegrationOAuth.hydrate(response);

        return agencyIntegrationOAuth;
      });
  }

  public deauthorizeAgencyIntegrationOAuth(userId: number, appName: string, options: object = {}) {
    return this.webAPI
      .deauthorizeAgencyIntegrationOAuth(userId, appName, options)
      .then((response) => {
        return response;
      });
  }
}
